(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kk-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kk-buy-now')) {
  customElements.define('kk-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      if (!this.form || !this.button || this.boundClick) return;
      this.boundClick = this.buy.bind(this);
      this.button.addEventListener('click', this.boundClick);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.form, {subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.boundClick) this.button?.removeEventListener('click', this.boundClick);
      this.boundClick = null;
    }
    sync() {
      const primary = this.form.querySelector('[name="add"]');
      const disabled = Boolean(this.busy || !primary || primary.disabled || primary.getAttribute('aria-disabled') === 'true');
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
    }
    async buy() {
      this.sync();
      if (this.button.disabled || !this.form.reportValidity()) return;
      const data = new FormData(this.form);
      if (!data.get('id')) return;
      data.delete('sections');
      data.delete('sections_url');
      this.busy = true;
      this.sync();
      this.button.setAttribute('aria-busy', 'true');
      this.error.hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {method: 'POST', headers: {'Accept': 'application/json'}, body: data});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error('cart');
        window.location.assign(this.dataset.checkoutUrl);
      } catch {
        this.error.textContent = 'Тауарды сатып алу мүмкін болмады. Таңдалған түрі мен санын тексеріп, қайта көріңіз.';
        this.error.hidden = false;
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.sync();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
